import React, {useState} from 'react';
import s from "./entity-constructor.module.css";

const EntityCard = ({entity, deleteEntity, updatedEntity}) => {
    const [isDel, setIsDel] = useState(false)
    return (
        <div className={s.wrapper}>
            <div>{entity.title}</div>
            <div className={s.titleField}>Описание: </div>
            <div>{entity.description}</div>
            {entity.helpTask? <div className={s.help}>Подсказка есть</div>:<></>}

            {isDel?<div>Удалено</div>:
                <>
                    <div onClick={()=>{updatedEntity(entity)}}
                         className={'btn'} >Изменить</div>

                    <div onClick={()=>{
                        if (window.confirm('Подтвердить удаление?'))
                            if(deleteEntity(entity.id))
                                setIsDel(true)
                    }}
                         className={'btn'} >Удалить</div>
                </>
            }

        </div>
    )
};

export default EntityCard;